// removed by extract-text-webpack-plugin
module.exports = {"QA-Icon":"QA-Icon","qaIcon":"QA-Icon","QA-Text":"QA-Text","qaText":"QA-Text","QA-Article":"QA-Article","qaArticle":"QA-Article","QA-Article__LeftAside":"QA-Article__LeftAside","qaArticleLeftAside":"QA-Article__LeftAside","QA-Article__RightAside":"QA-Article__RightAside","qaArticleRightAside":"QA-Article__RightAside","QA-Article__Main":"QA-Article__Main","qaArticleMain":"QA-Article__Main"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/__future__/QAComponents.scss
// module id = 686
// module chunks = 0